// extracted by mini-css-extract-plugin
export var btn = "flowStepPhone-module--btn--f510a";
export var inner = "flowStepPhone-module--inner--fd767";
export var subtitle = "flowStepPhone-module--subtitle--e8ea1";